import PropTypes from 'prop-types';
import React from 'react';

export default class ClickListener extends React.Component {
    static propTypes = {
        children: PropTypes.element.isRequired,
        onClickOutside: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.handleRef = this.handleRef.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(evt) {
        if (this.element) {
            if (this.element.contains && !this.element.contains(evt.target)) {
                return this.props.onClickOutside(evt);
            }
        }
    }

    handleRef(el) {
        const { children } = this.props;
        this.element = el;
        if (children.ref && typeof children.ref === 'function') {
            children.ref(el);
        }
    }

    render() {
        return React.cloneElement(this.props.children, {
            ref: this.handleRef
        });
    }
}

const clickHandles = [];
document.addEventListener('click', function(evt) {
    if (clickHandles.length) {
        clickHandles.forEach(obj => {
            if (obj.element) {
                if (obj.element.contains && !obj.element.contains(evt.target)) {
                    return obj.cb(evt);
                }
            }
        });
    }
});

function clickOutSideDoc(ref, cb) {
    const obj = {
        element: ref,
        cb
    };

    clickHandles.push(obj);

    return () => {
        const index = clickHandles.indexOf(obj);
        if (index !== -1) {
            clickHandles.splice(index, 1);
        }
    };
}

class DocClickManger extends React.PureComponent {
    static propTypes = {
        el: PropTypes.instanceOf(Element).isRequired,
        onDocClick: PropTypes.func.isRequired
    };

    componentDidMount() {
        this.disposeClick = clickOutSideDoc(this.props.el, () => {
            this.props.onDocClick();
        });
    }

    componentWillUnmount() {
        this.disposeClick();
    }

    render() {
        return null;
    }
}

export { clickOutSideDoc, DocClickManger };
